if (document.querySelector('.swiper.carousel')) {
    import('./swiper');
}
